import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { FreeAuditPage } from "@/components/audit/FreeAuditPage";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/audit/")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Free Shopify Audit: Performance, Technical SEO, CRO & AI Readability · Shugert",
    description: "Run a free 30–60 second scan of public Shopify performance, technical SEO, buying-experience and AI-readability signals. See a score and priority finding before unlocking the detailed checks.",
    path: "/audit",
    altPath: alternatePath("/audit", "es"),
    jsonLd: breadcrumbJsonLd([
      { name: "Home", path: "/" },
      { name: "Free Shopify Audit", path: "/audit" },
    ]),
  }),
  component: () => (
    <SiteShell>
      <FreeAuditPage locale="en" />
    </SiteShell>
  ),
});
